import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

type B3ModalElement = HTMLElement & { open?: boolean };

@Component({
  standalone: false,
  selector: 'app-project-validation-reject-confirm-modal',
  templateUrl: './project-validation-reject-confirm-modal.component.html',
  styleUrls: ['./project-validation-reject-confirm-modal.component.scss'],
})
export class ProjectValidationRejectConfirmModalComponent {
  @ViewChild('rejectConfirmModal') rejectConfirmModal?: ElementRef<B3ModalElement>;

  @Input() open = false;
  @Input() heading = 'Confirmar rejeição?';
  @Input() message = 'Não será possível enviar novos comentários ou alterar comentários adicionados.';

  @Output() closed = new EventEmitter<boolean>();

  onCancel(): void {
    this.closeModal(false);
  }

  onConfirm(): void {
    this.closeModal(true);
  }

  onModalDismiss(): void {
    this.closeModal(false);
  }

  private closeModal(confirmed: boolean): void {
    const modalHost = this.rejectConfirmModal?.nativeElement;
    if (modalHost) {
      modalHost.open = false;
    }

    document.querySelectorAll('dialog[open]').forEach(element => {
      if (element instanceof HTMLDialogElement) {
        element.close();
      }
    });

    this.closed.emit(confirmed);
  }
}
